import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {Box, Flex, Img, Text, useMultiStyleConfig} from '@chakra-ui/react'
import CurrentPrice from '../../../display-price/current-price'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getPriceData} from '../../../../utils/product-utils'
import OmnibusPrice from '../../../display-price/omnibus-price'
import {getGlobalLink} from '../../../../utils/contentstack-utils'
import {useProducts} from '@salesforce/commerce-sdk-react'
import {breakpoints} from '../../../../theme/_utils'

const getFirstImage = (product, viewType) => {
    const images = product?.imageGroups?.find((group) => group.viewType == viewType)?.images
    return images && images?.length > 0 ? images[0] : {}
}

const ProductBox = ({product, styleVariant}) => {
    const styles = useMultiStyleConfig('ProductMoodboard', {variant: styleVariant})

    const {locale} = useMultiSite()

    const smallImage = getFirstImage(product, 'small')
    const mediumImage = getFirstImage(product, 'medium')

    const priceData = getPriceData(product || {})
    const {data: productsData} = useProducts(
        {
            parameters: {
                ids: product?.id || '',
                expand: ['availability', 'images'],
            },
            headers: {
                'x-debug': 'product-box-index',
            },
        },
        {
            enabled: Boolean(product?.id),
        },
    )
    const {url, label} = getGlobalLink({
        link: {productsfcc: {data: [{id: product?.id || ''}]}},
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })

    return (
        <Flex
            data-testid="product-box"
            as={Link}
            to={url ?? '#'}
            title={label}
            {...styles.productbox}
        >
            <Box {...styles.imagecontainer} className={'img-container'}>
                <picture style={{display: 'contents'}}>
                    <source
                        media={`(min-width: ${breakpoints.lg})`}
                        srcSet={mediumImage?.link || ''}
                    />
                    <Img
                        src={smallImage?.link || ''}
                        alt={smallImage?.alt || ''}
                        {...styles.image}
                    />
                </picture>
                <Box {...styles.imageoverlay} />
            </Box>
            <Flex {...styles.textbox}>
                <Text {...styles.productId}>{product?.id || <>&nbsp;</>}</Text>
                <Text {...styles.productName}>
                    {product?.c_variantIdentifier || product?.productName || product?.name || (
                        <>&nbsp;</>
                    )}
                </Text>
                {product?.price && product?.currency ? (
                    <CurrentPrice
                        price={product?.price}
                        currency={product?.currency}
                        {...styles.price}
                    />
                ) : (
                    <Text {...styles.price}>&nbsp;</Text>
                )}
                <Flex {...styles.omnibusPrice}>
                    {(priceData?.showOmnibusPrice || priceData?.showOmnibusPriceDiscount) &&
                    product?.currency ? (
                        <OmnibusPrice
                            priceData={priceData}
                            currency={product?.currency}
                            omnibusExpandedView={false}
                            showDiscount={true}
                            variant={'recommended'}
                        />
                    ) : (
                        <>&nbsp;</>
                    )}
                </Flex>
            </Flex>
        </Flex>
    )
}

ProductBox.propTypes = {
    product: PropTypes.shape(),
    styleVariant: PropTypes.string,
}

export default ProductBox
